// extracted by mini-css-extract-plugin
module.exports = {"contact":"contact-module--contact--2-4uZ","note":"contact-module--note--h2dWI","msg":"contact-module--msg--2OB4E"};